var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVivo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#408AF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9651 5.78086C13.025 5.67897 13.1048 5.59013 13.1996 5.51956C13.2944 5.44899 13.4025 5.39812 13.5173 5.36997C13.6321 5.34182 13.7514 5.33694 13.8681 5.35563C13.9848 5.37432 14.0966 5.4162 14.1969 5.4788C14.6188 5.74317 14.7516 6.30567 14.4928 6.73711C13.5343 8.33349 12.4526 10.0041 11.5509 11.2799C10.2347 13.1417 9.94949 13.7813 8.99999 13.7813C8.05049 13.7813 7.83674 13.2171 6.4828 11.2748C5.67843 10.1217 4.66987 8.57761 3.51843 6.75455C3.38945 6.55051 3.34521 6.30418 3.39511 6.06801C3.44501 5.83184 3.58512 5.62447 3.78562 5.49005C3.88436 5.42503 3.99514 5.38046 4.11141 5.35897C4.22767 5.33749 4.34706 5.33952 4.46253 5.36495C4.57799 5.39038 4.68719 5.4387 4.78367 5.50704C4.88014 5.57538 4.96195 5.66237 5.02424 5.76286C6.16218 7.56399 8.7328 11.3181 9.0073 11.6528C9.29418 11.313 12.0291 7.34011 12.9651 5.7803V5.78086Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVivo);
export default __webpack_public_path__ + "static/media/vivo.57f29f513b4dade8e566d5681b712f17.svg";
export { ForwardRef as ReactComponent };